import { AgResourceLanguage } from '../types';
import { cart as EnUsCart } from '../en-us/cart';

export const cart: AgResourceLanguage['cart'] = {
  ...EnUsCart,
  subscriptionTitle: 'Suscripción',
  oneTimeTitle: 'Compra Única',
  giftCartTitle: 'Pedido de Regalo',
  oneTimeDescription: 'Estos artículos se entregarán con tu primer pedido de suscripción:',
  oneTimeCarouselTitle: 'También te podría gustar',
  clearCartText: 'Eliminar productos',
  oneTimeCarouselAddButton: 'Añadir',
  title: 'Tu Carrito',
  checkoutButtonLabel: 'Pagar',
  emptyState: {
    oneTimeProductsTitle: 'Favoritos de los Miembros',
    addOneTimeProductButton: 'Añadir al Carrito',
    label: 'Añade artículos a tu carrito'
  },
  emptyStateLabel: 'Añade artículos a tu carrito',
  frequencyLabel: 'Enviado cada 30 días:',
  deliveryInfo:
    'Una vez que completes el pago, tu pedido será enviado dentro de las 24 horas (L-V) posteriores al pago. Ten en cuenta que los fines de semana y días festivos pueden tardar hasta 48 horas.',
  deleteItemModal: {
    title: 'Eliminar Artículos del Carrito',
    description: '¿Estás seguro de que deseas eliminar artículos de tu carrito?'
  },
  clearCartModal: {
    title: 'Eliminar Todos los Artículos del Carrito',
    description: '¿Estás seguro de que deseas eliminar todos los artículos de tu carrito?'
  },
  free: 'Gratis',
  scoopPrompt: '¿Necesitas una cuchara con tu bolsa? Añádela gratis a continuación.'
};
